import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
@Component({
  selector: 'app-welcome-message',
  templateUrl: './welcome-message.component.html',
  styleUrls: ['./welcome-message.component.scss'],
})
export class WelcomeMessageComponent  implements OnInit {

  constructor(private location: Location) {}

  goBack() {
    this.location.back(); // Navigate to the previous page
  }

  ngOnInit() {}

}
